<template>
  <component :is="componentToRender" />
</template>

<script>
import TenantCreditPack from "@/pages/purchase-order/orders-list.vue";
import ClientCreditPack from "@client-app/pages/purchase-orders/order-list.vue";
export default {
  name: "CreditPackWrapper",
  computed: {
    componentToRender() {
      console.log("Rendering component based on user type", this.$store?.getters?.getIsClient);
      return this.$store?.getters?.getIsClient
        ? ClientCreditPack
        : TenantCreditPack;
    },
  },
};
</script>
